module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('common-config', {
    staticClass: "fl m-r-20 bor-r-ccc w-600",
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('div', {
    staticClass: "export-config-left"
  }, [_c('el-form-item', {
    attrs: {
      "label": "允许用户选择导出列"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.choose_column),
      expression: "form.choose_column"
    }],
    domProps: {
      "value": (_vm.form.choose_column)
    },
    on: {
      "input": function($event) {
        _vm.form.choose_column = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("允许")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不允许")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "导出内容"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.export_type),
      expression: "form.export_type"
    }],
    domProps: {
      "value": (_vm.form.export_type)
    },
    on: {
      "input": function($event) {
        _vm.form.export_type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("同列表")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("自定义配置")])])]), _vm._v(" "), (_vm.isSelfConfig) ? _c('list-table', {
    ref: "listTable",
    staticStyle: {
      "width": "550px"
    },
    attrs: {
      "fields": _vm.inputList,
      "tableData": _vm.form.export_config.column,
      "isSimple": true,
      "hasImport": true
    },
    on: {
      "addCol": _vm.addCol,
      "deleteCol": _vm.deleteCol,
      "setColConfig": _vm.setColConfig,
      "showImport": _vm.showImport
    }
  }) : _vm._e()])])], true), _vm._v(" "), _c('div', {
    staticClass: "export-config-right"
  }, [(_vm.showColConfig && _vm.isShowRightList) ? _c('col-config', {
    staticClass: "fl",
    attrs: {
      "col": _vm.currentCol,
      "fields": _vm.inputList,
      "tables": _vm.models,
      "isSimple": true
    }
  }) : _vm._e()]), _vm._v(" "), _c('field-list', {
    ref: "fieldList",
    attrs: {
      "fields": _vm.inputList
    },
    on: {
      "importFields": _vm.importFields
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97967dba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/exportConfig.vue
// module id = 1961
// module chunks = 2